import * as React from "react";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section id="hero" className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden bg-background py-24 md:min-h-[600px] lg:min-h-[800px]">
      {}
      <div className="absolute inset-0 z-0 h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598117/img/active_seniors_lifestyle.png)] bg-cover bg-fixed bg-center bg-no-repeat" />

      {}
      <div className="absolute inset-0 z-0 bg-secondary/40 mix-blend-multiply" />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-secondary/60 via-secondary/30 to-secondary/60" />

      {}
      <div className="container relative z-10 mx-auto flex flex-col items-center px-4 text-center md:px-6">
        <div className="animate-in fade-in slide-in-from-bottom-4 flex max-w-4xl flex-col items-center duration-1000 ease-out">
          <h1 className="mb-6 text-4xl font-bold tracking-tight text-white drop-shadow-lg md:text-[42px] lg:text-5xl lg:leading-tight">
            瑞聲助聽器到府服務團隊
          </h1>
          
          <p className="mb-10 max-w-2xl text-lg font-light leading-relaxed text-white/95 drop-shadow-md md:text-xl">
            我們提供專屬到府服務，為您量身打造最適合的聽力解決方案，讓溝通不再有距離。
          </p>

          <div className="flex w-full flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
            <Button asChild size="lg" className="group h-21 rounded-full bg-primary px-16 text-3xl font-medium text-primary-foreground shadow-[0_0_20px_var(--color-primary)] shadow-primary/40 transition-all duration-300 hover:bg-primary/90 hover:shadow-[0_0_30px_var(--color-primary)] hover:shadow-primary/60">
              <Link to="https://ynews.page.link/eB49N" newTab>
                媒體報導
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="h-21 rounded-full border-white/30 bg-white/10 px-16 text-3xl font-medium text-white backdrop-blur-sm transition-all duration-300 hover:bg-white/20 hover:text-white">
              <Link to="https://interton.com.tw/category/%e5%af%a6%e7%b8%be%e6%a1%88%e4%be%8b%e5%88%86%e4%ba%ab/">
                <Phone className="mr-4 size-10" />
                服務實績
              </Link>
            </Button>
          </div>
        </div>
      </div>

      </section>;
}